import {
	TCreatorReportProcess,
	ICreatorReportListDB,
	ICreatorProfileDB,
	ICreatorGroupSummaryDB,
	ICreatorGroupPerformanceDB,
	ICreatorContentDB,
	ICreatorContentsDetailsDB,
	ICreatorDailyPerformanceDB,
	ICreatorGroupsDB,
} from 'type/db';

import { api } from './api';

export const wconcept_creator_apis = {
	//크리에이터 목록
	//GET /api/groups/{groupId}/creators?progress=""
	getCreatorReportsList: async (groupId: string, progress: TCreatorReportProcess) => {
		const data = await api.get(`api/groups/${groupId}/creators?progress=${progress}`);
		return data.data as ICreatorReportListDB[];
	},

	// GET /creators/{creatorPk}/profile
	getCreatorProfile: async (creatorPk: string) => {
		const data = await api.get(`api/creators/${creatorPk}/profile`);
		return data.data as ICreatorProfileDB;
	},

	//GET /api/creators/{creatorPk}/groups/{groupId}/summary
	getCreatorGroupSummary: async (creatorPk: string, groupId: string) => {
		const response = await api.get(`api/creators/${creatorPk}/groups/${groupId}/summary`);
		return response.data as ICreatorGroupSummaryDB;
	},
	//GET /api/creators/{creatorPk}/groups/{groupId}/missions/{missionNumber}/performances/daily
	getCreatorMissionPerformanceDaily: async (
		creatorPk: string,
		groupId: string,
		missionNumber: string,
	) => {
		const response = await api.get(
			`api/creators/${creatorPk}/groups/${groupId}/missions/${missionNumber}/performances/daily`,
		);
		return response.data as ICreatorDailyPerformanceDB;
	},

	//GET /api/creators/{creatorPk}/groups/{groupId}/performances
	getCreatorGroupPerformances: async (creatorPk: string, groupId: string) => {
		const response = await api.get(
			`api/creators/${creatorPk}/groups/${groupId}/performances`,
		);
		return response.data as ICreatorGroupPerformanceDB;
	},
	//GET /api/creators/{creatorPk}/contents
	getCreatorContents: async (creatorPk: string) => {
		const response = await api.get(`api/creators/${creatorPk}/contents`);
		return response.data as ICreatorContentDB[];
	},
	//GET /api/creators/{creatorPk}/contents/{contentPk}/details
	getCreatorContentDetails: async (creatorPk: string, contentPk: number) => {
		const response = await api.get(
			`api/creators/${creatorPk}/contents/${contentPk}/details`,
		);
		return response.data as ICreatorContentsDetailsDB;
	},

	getCreatorGroups: async (creatorPk: string) => {
		const data = await api.get(`api/creators/${creatorPk}/groups`);
		return data.data as ICreatorGroupsDB[];
	},
};
